import React from "react";
import style from "./style.module.css";

interface RightTableProps {
  regionName: string;
  organizations: string[];
}

export const RightTable: React.FC<RightTableProps> = ({ regionName, organizations }) => {
  return (
    <div className={style.rightTableContainer}>
      <div className={style.header}>
        Данные по области <b>{regionName}</b>
      </div>
      <div className={style.searchWrapper}>
        {/* <input className={style.searchInput} placeholder="Поиск" /> */}
      </div>
      <div className={style.table}>
        <div className={style.tableHeader}>Организации</div>
        <div className={style.tableBody}>
          {organizations.length === 0 ? (
            <div className={style.noData}>Нет данных</div>
          ) : (
            organizations.map((name, idx) => (
              <div className={style.tableRow} key={idx}>
                {name}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};   